import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { CommonService } from '../../../../services/common';
import { DocumentsService } from '../../../../services/common/documents.service';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { SalesService } from '../../sales.service';
import { ToasterService } from '../../../../services/common/toaster.service';
import { ErrorMessages } from '../../../../../errormessages';
import { JwtService } from '../../../../auth/jwtservice';
import { TokenPropertyUrl, DocumentSubType } from '../../../../../appconfig';
import { CallingService } from '../../../../services/common/calling.service';
import { firstValueFrom } from 'rxjs';
declare const $: any;

@Component({
  selector: 'app-booking-list',
  templateUrl: './booking-list.component.html',
  styleUrl: './booking-list.component.scss'
})
export class BookingListComponent implements OnInit, OnChanges {
  @Input() bookingListData: any;
  @Output() changeModelStatus = new EventEmitter<any>();
  @Output() changeDocumentModelStatus = new EventEmitter<any>();
  addIcon: string = environment.assetsImagePath + IconList.AddbuttonIcon
  paymentIcon: string = environment.assetsImagePath + IconList.PaymentIcon
  documentIcon: string = environment.assetsImagePath + IconList.DocumentIcon
  editIcon: string = environment.assetsImagePath + IconList.EditIconDropdown
  cancelIcon = environment.assetsImagePath + IconList.AllotmentCancelIcon
  allotmentIcon: string = environment.assetsImagePath + IconList.AllotmentIcon
  receivedAmountIcon: string = environment.assetsImagePath + IconList.receivedMoneyIcon
  cancellationScreenshotIcon: any = environment.assetsImagePath + IconList.AddIcon
  // rowData:any
  form!: FormGroup
  isVisible: boolean = false;
  Project: any = null;
  showExport: boolean = false;
  exportSelectedType: string = '';
  frameworkComponents: any;
  columnDefs!: any[];
  defaultColDef: any;
  excelStyles: any[] = [];
  gridOptions: any;

  overlayNoRowsTemplate: string = '<span>No records found</span>';
  dropdownMenu: any
  isDropdownOpen = false;
  ActionList: boolean = false;
  isDocument: boolean = false;
  addressProof = true;
  fileName = '';
  context: any
  filterTerm!: string;
  data!: any[];
  selectedExportData: any[] = [];
  projectId: any;
  //#region AG GRID Columns Settings
  columnKeys: any[] = [
    'customerName',
    'product',
    'sourceName',
    'amount',
    'contactNumber',
  ];

  exportColumns: any[] = []
  dialogData = { title: '', message: '' };
  showDialog = false;
  cancelledRowData: any;
  rowStyles: any[] = [];

  viewContactModal: boolean = false;

  // Cancellation modal properties
  showBookingCancellationDialogue: boolean = false;
  showCancellationModalComponent: boolean = false;
  cancellationModalMode: 'create' | 'edit' = 'create';

  cancellationReason: string = '';
  bookingCancellationDate: Date = new Date();
  maxDate: Date = new Date();
  cancellationScreenshot: any;
  uploadedCancellationFile: any;
  displayDocumentFileDialogue: boolean = false;
  documentFileData: any;
  showclickedPic: boolean = false;
  picViewData: any;

  currentUserContactNumber: any;
  viewedContactNumber: any;
  showCallIcon: boolean = false;
  roleListData: any;
  showContactIcon: boolean = false;

  constructor(private router: Router, private toastr: ToasterService,
    public commonService: CommonService,
    private salesService: SalesService,
    private jwtService: JwtService,
    private callingService: CallingService,
    private toasterService: ToasterService,
    private documentsService: DocumentsService) {
    this.context = this

  }

  async ngOnInit() {
    this.roleListData = await firstValueFrom(this.jwtService.currentUserRole$());
    //  this.getRoleList();
    if (this.roleListData.includes('View_Client_Contacts')) {
      this.showContactIcon = true;
    } else {
      this.showContactIcon = false;
    }

    if (this.roleListData.includes('Can_Call_Client')) {
      this.showCallIcon = true;
    } else {
      this.showCallIcon = false;
    }

    this.columnDefs = [
      // @ts-ignore
      {

        field: 'selection', columnType: 'checkbox'
      }, {
        header: 'Booking #', field: 'id', columnType: 'text'
      },
      {
        header: 'Client Name', field: 'clientName', columnType: 'text'
      },
      {
        header: 'Agent Name', field: 'sourceName', columnType: 'text'
      },
      {
        header: 'Unit Category',
        field: 'product',
        columnType: 'text',

      },
      {
        header: 'Amount',
        field: 'amount',
        columnType: 'text'
      },
      {
        header: 'Received Amount',
        field: 'recivedAmount',
        columnType: 'text'
      },
      {
        header: 'Contact No',
        field: 'contactNumber',
        columnType: 'phone'
      },
      {
        header: 'Actions', field: 'action', columnType: 'dropdown', options: [
          { label: 'Payment', value: 'receipt', icon: this.paymentIcon },
          { label: 'Document', value: 'document', icon: this.documentIcon },
          { label: 'Allotment', value: 'allotments', icon: this.allotmentIcon },
          { label: 'Edit', value: 'edit', icon: this.editIcon },
          { label: 'Cancel', value: 'cancel', icon: this.cancelIcon }
        ]
      }
    ];
  }

  onCommonTableDropdownChange(event: { route: any, currentRow: any }) {
    const selectedRoute = event?.route;
    this.salesService.currentBooking = event?.currentRow;
    if (selectedRoute == 'receipt') {
      this.NavigateToPaymentRoute(event?.currentRow)
    } else if (selectedRoute == 'allotments') {
      this.NavigateToAllotmentRoute(event?.currentRow)
    } else if (selectedRoute == 'document') {
      this.changeDocumentModelStatus.emit({
        "currentSelectedRecord": event.currentRow
      })
    } else if (selectedRoute == 'cancel') {
      this.cancelledRowData = event.currentRow;
      this.showConfirmation();
    }

    if (selectedRoute == 'edit') {
      this.changeAddUpdateModalState(event.currentRow, 'Edit')
    }
  }

  showConfirmation() {
    this.showDialog = true;
    this.dialogData = { title: 'Confirm Booking Cancellation', message: 'Are you sure you want to cancel this booking?' };
  }

  /**
   * On user confirmation of booking cancellation gather cancellation details from user
   * @param result 
   */
  onConfirmed(result: any) {
    if (result) {
      // Show the new reusable cancellation modal component
      this.cancellationModalMode = 'create';
      this.showCancellationModalComponent = true;
      this.bookingCancellationDate = new Date()
      this.bookingCancellationDate.setHours(0, 0, 0, 0);
    }
    this.showDialog = false; // Hide dialog after confirmation booking cancellation or closing
  }

  /**
   * Handle cancellation modal successful submission
   */
  onCancellationSuccessfulSubmit(event: any): void {
    // Refresh booking list when cancellation is successful
    this.changeModelStatus.emit({
      "showaddUpdateModal": false,
      "isCancelled": true
    });
  }

  /**
   * Handle cancellation modal close event
   */
  onCancellationModalClose(): void {
    this.showCancellationModalComponent = false;
  }

  /**
   * Confirms the booking cancellation after user provides necessary details
   */
  confirmBookingCancellation() {
    let documentDetails = null;

    // Build documentDetails object if file is uploaded
    if (this.uploadedCancellationFile) {
      documentDetails = {
        isActive: true,
        isVerified: false,
        docType: this.uploadedCancellationFile.document.name.split('.').pop(),
        fileBase64: this.cancellationScreenshot,
        documentSubTypeId: DocumentSubType['BookingCancellationRequest'],
        bookingId: this.cancelledRowData?.id,
        projectId: this.cancelledRowData?.projectDetail?.id
      };
    }

    var cancellationData = {
      bookingId: this.cancelledRowData?.id,
      requestRemark: this.cancellationReason,
      requestedOn: this.bookingCancellationDate,
      documentDetails: documentDetails
    }

    // User confirmed, perform cancel booking.
    this.salesService.MarkBookingForCancellation(cancellationData).subscribe((result: any) => {
      this.toastr.showSuccess(ErrorMessages.bookingCancellationRequest);

      this.changeModelStatus.emit({
        "showaddUpdateModal": false,
        "isCancelled": true
      });
      this.showBookingCancellationDialogue = false;
      this.cancellationReason = '';
      this.bookingCancellationDate = new Date();
      this.bookingCancellationDate.setHours(0, 0, 0, 0);
    }), (error: any) => {
      this.toastr.showError(error?.error?.message ?? ErrorMessages.GeneralError);
    }
  }

  /**
   * Sets config of current file to be uploaded for booking cancellation request.
   * @param documentSubType "Sub Type of document for which file needs to be uploaded"
   */
  setCurrentFileConfig(documentSubType: any) {
    if (this.documentFileData) {
      this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType),
        this.documentFileData.showDocumentNumber = false;
    } else {
      this.documentFileData = {
        'picFor': this.commonService.addSpaceInCamelCase(documentSubType),
        "documentSubTypeId": DocumentSubType[documentSubType],
        'operationMode': 'add',
      }
    }
    this.displayDocumentFileDialogue = true
    this.documentFileData.documentNoHide = false
  }

  /**
   * Receives the uploaded screenshot for booking cancellation request
   * @param receivedPicData file data received from document-file component
   */
  ReceiveCancellationScreenshot(receivedPicData: any) {
    if (receivedPicData && receivedPicData?.documentFile) {
      this.cancellationScreenshot = receivedPicData?.documentFile?.documentByte
      this.uploadedCancellationFile = receivedPicData?.documentFile;
      this.cancellationScreenshotIcon = environment.assetsImagePath + IconList.EditIcon
    } else {
      this.cancellationScreenshot = null;
      this.cancellationScreenshotIcon = environment.assetsImagePath + IconList.AddIcon
    }
    this.displayDocumentFileDialogue = false;
  }

  /**
   * Opens image preview viewer for cancellation screenshot
   * @param imageName name of image to display
   * @param imageData image data or empty string
   */
  setClickPicView(imageName: string, imageData: string) {
    if (this.cancellationScreenshot) {
      // Remove data URL prefix if present
      const base64String = this.cancellationScreenshot.includes(',')
        ? this.cancellationScreenshot.split(',')[1]
        : this.cancellationScreenshot;

      this.picViewData = {
        'picTitle': imageName,
        'picFile': base64String,
        'fileType': this.commonService.getFileTypeFromBase64String(this.cancellationScreenshot)
      };
      this.showclickedPic = true;
    }
  }

  /**
   *
   * @param changes Refresh grid data on project change
   */
  ngOnChanges(changes: SimpleChanges): void {
    // this.setGridRowData();
    this.setRowStyles();
  }

  /**
   * Changes the current visibility state of booking document modal
   * @param modalState current visibility state of modal (true/false)
   * @param currentRecord current record for which booking document modal has to be opened
   */
  changeDocumentModelState(modalState: boolean = false, currentRecord: any) {

    this.changeDocumentModelStatus.emit({
      "showDocumentModal": modalState,
      "currentSelectedRecord": currentRecord
    });
  }

  changeAllotmentModelState(modalState: boolean = false, currentRecord: any) {
    // always update currentBooking
    this.salesService.currentBooking = currentRecord;
    this.NavigateToAllotmentRoute(currentRecord);
    this.salesService.$currentBookingChanged.next(this.salesService.currentBooking);
  }

  /**
   * Change the current visibility status of Add/Update modal
   * @param currentRecord Currentlty Selected record for which modal has to be opened in edit mode (Only Mobile View). In
   * laptop view it will be set by custom dropdown component
   */
  changeAddUpdateModalState(currentRecord?: any, context?: string) {
    // always update currentBooking
    this.salesService.currentBooking = currentRecord;
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord,
      context: context,
      "bookingListData": this.bookingListData
    });
    this.commonService.setActionType(context);
    this.salesService.$currentBookingChanged.next(this.salesService.currentBooking);
  }

  /**
  * to toggle the action menu on booking table
  * @param paymentId
  */
  toggleActonMenu(paymentId: any) {
    this.dropdownMenu = document.getElementById(
      'actionMenuContent' + paymentId
    );
    this.dropdownMenu?.classList.toggle('dropdownActionMenu');
    this.ActionList = !this.ActionList;
  }

  /**
   * navigate to payment route of this booking. (Current record passed from custom dropdown)
   * @param {any} currentRecord current record whose payment has to be fetched.
   */
  NavigateToPaymentRoute(currentRecord: any) {
    this.router.navigate(['sales/booking/' + currentRecord?.id + '/receipts']);
  }

  NavigateToAllotmentRoute(currentRecord: any) {
    this.router.navigate(['sales/booking/' + currentRecord?.id + '/allotment']);
  }

  DocumentRoute(currentRecord: any) {
    this.changeModelStatus.emit({
      "showaddUpdateModal": false,
      "showDocumentModal": true,
      "currentSelectedRecord": currentRecord
    })
  }

  //#region EXPORT Feature
  // to show export options like pdf and excel
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
  * to show export modal as per selected option
  * @param {string} type
  */
  toggleExport(type: string) {
    this.exportSelectedType = type;
    this.showExport = !this.showExport;
  }

  /**
  * set data to form after exporting the selected data
  * @param {any} data
  */
  exportValues(data: any) {
    if (data) {
      this.form.controls['customerName'].setValue(data[0]?.clientName);
      this.form.controls['amount'].setValue(data[0]?.amount);
      this.showExport = false;
    }
  }

  // to hide export modal
  hideExport() {
    this.showExport = false;
    $('.modal').modal('hide');
  }
  //#endregion

  onSelectedRowsChange(selectedRows: any) {
    this.selectedExportData = [];
    let exportedObject: any[] = [];

    if (selectedRows?.length > 0)
      selectedRows.forEach((row: any) => {
        let customerDetailObject = row?.clientDetail;
        if (customerDetailObject) {
          let rowData = {
            "Booking #": row?.id,
            "Client Name": customerDetailObject?.nameInitialsName + ' ' +
              customerDetailObject?.firstName + ' ' +
              customerDetailObject?.lastName,
            "Agent Name": row?.sourceName,
            "Booking Date": row?.bookingDate != undefined ? (row?.bookingDate.split('T')[0]) : "",
            "Unit Category": row?.product,
            "Amount": row?.amount,
            "Contact No": row?.contactNumber_Copy
          };
          exportedObject.push(rowData);
        }
      });

    this.selectedExportData = exportedObject;
  }

  onClickEyeOfContactColumn(cellData: any) {
    this.viewContactModal = true
    this.viewedContactNumber = cellData;
    this.currentUserContactNumber = this.jwtService.getUserPropertyValueFromToken(TokenPropertyUrl.contactNumber).replace(/(\d{5})(\d{5})/, '$1-$2');
  }

  clickToCall(event: any) {
    event.preventDefault();
    const callContactData = {
      to: this.viewedContactNumber.replace(/-/g, '').toString(),
      from: this.currentUserContactNumber.replace(/-/g, '').toString()
    }
    this.callingService.postCallContacts(callContactData).subscribe({
      next: (response) => {
        this.toasterService.showSuccess('You will receive call shortly.')
      },
      error: (err) => {
        this.toasterService.showError('System is not able to connect, Kindly connect with administrator.')
      }
    })
  }

  /**
 * Set row styles based on the isRequestedForCancellation property of each row.
 * @returns 
 */
  setRowStyles(): void {
    if (!this.bookingListData) {
      return; // If bookingListData is undefined, exit the function
    }
    this.rowStyles = this.bookingListData.map((row: any) => {
      return {
        id: row?.id,
        style: row?.isRequestedForCancellation ? { 'background-color': 'rgba(45, 212, 191, 0.15)' } : {}
      };
    });
  }
}
